/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Invite_Footer_PlusInputs */

const en_invite_footer_plus = /** @type {(inputs: Invite_Footer_PlusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`People you invite get 300 coins, plus 30 Time Crystals from your Plus membership.`)
};

const ar_invite_footer_plus = /** @type {(inputs: Invite_Footer_PlusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`يحصل الأشخاص الذين تدعوهم على 300 عملة، بالإضافة إلى 30 بلورة زمنية من عضوية Plus الخاصة بك.`)
};

const de_invite_footer_plus = /** @type {(inputs: Invite_Footer_PlusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Von dir eingeladene Personen erhalten 300 Münzen plus 30 Zeitkristalle durch deine Plus-Mitgliedschaft.`)
};

const es_invite_footer_plus = /** @type {(inputs: Invite_Footer_PlusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Las personas que invites reciben 300 monedas, más 30 Cristales de Tiempo gracias a tu membresía Plus.`)
};

const fr_invite_footer_plus = /** @type {(inputs: Invite_Footer_PlusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Les personnes que vous invitez reçoivent 300 pièces, plus 30 Cristaux de Temps grâce à votre abonnement Plus.`)
};

const it_invite_footer_plus = /** @type {(inputs: Invite_Footer_PlusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le persone che inviti ricevono 300 monete, più 30 Cristalli del Tempo grazie al tuo abbonamento Plus.`)
};

const ja_invite_footer_plus = /** @type {(inputs: Invite_Footer_PlusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`招待した人は300コインに加えて、あなたのPlusメンバーシップにより30個のタイムクリスタルを獲得できます。`)
};

const ko_invite_footer_plus = /** @type {(inputs: Invite_Footer_PlusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`초대한 사람은 코인 300개와 내 Plus 멤버십으로 시간 크리스탈 30개를 추가로 받아요.`)
};

const pt_br_invite_footer_plus = /** @type {(inputs: Invite_Footer_PlusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`As pessoas que você convidar ganham 300 moedas, mais 30 Cristais do Tempo pela sua assinatura Plus.`)
};

const ru_invite_footer_plus = /** @type {(inputs: Invite_Footer_PlusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Приглашенные вами люди получают 300 монет и еще 30 Кристаллов времени благодаря вашей подписке Plus.`)
};

const th_invite_footer_plus = /** @type {(inputs: Invite_Footer_PlusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`คนที่คุณเชิญจะได้รับ 300 เหรียญ พร้อมคริสตัลเวลาอีก 30 ชิ้นจากสมาชิก Plus ของคุณ`)
};

const tr_invite_footer_plus = /** @type {(inputs: Invite_Footer_PlusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Davet ettiğin kişiler 300 jeton ve Plus üyeliğinden gelen 30 Zaman Kristali alır.`)
};

const zh_cn_invite_footer_plus = /** @type {(inputs: Invite_Footer_PlusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`你邀请的人可获得 300 金币，并透过你的 Plus 会员资格额外获得 30 颗时光宝石。`)
};

const zh_tw_invite_footer_plus = /** @type {(inputs: Invite_Footer_PlusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`你邀請的人可獲得 300 金幣，並透過你的 Plus 會員資格額外獲得 30 顆時光寶石。`)
};

/**
* | output |
* | --- |
* | "People you invite get 300 coins, plus 30 Time Crystals from your Plus membership." |
*
* @param {Invite_Footer_PlusInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const invite_footer_plus = /** @type {((inputs?: Invite_Footer_PlusInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Invite_Footer_PlusInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_invite_footer_plus(inputs)
	if (locale === "ar") return ar_invite_footer_plus(inputs)
	if (locale === "de") return de_invite_footer_plus(inputs)
	if (locale === "es") return es_invite_footer_plus(inputs)
	if (locale === "fr") return fr_invite_footer_plus(inputs)
	if (locale === "it") return it_invite_footer_plus(inputs)
	if (locale === "ja") return ja_invite_footer_plus(inputs)
	if (locale === "ko") return ko_invite_footer_plus(inputs)
	if (locale === "pt_br") return pt_br_invite_footer_plus(inputs)
	if (locale === "ru") return ru_invite_footer_plus(inputs)
	if (locale === "th") return th_invite_footer_plus(inputs)
	if (locale === "tr") return tr_invite_footer_plus(inputs)
	if (locale === "zh_cn") return zh_cn_invite_footer_plus(inputs)
	return zh_tw_invite_footer_plus(inputs)
});